export default __webpack_public_path__ + "static/media/su-logo.3ed8bf77.svg";